"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateRoute = void 0;
var React = require("react");
var react_router_1 = require("react-router");
var react_redux_1 = require("react-redux");
var index_1 = require("../../../model/index");
var PrivateRouteComponent = /** @class */ (function (_super) {
    __extends(PrivateRouteComponent, _super);
    function PrivateRouteComponent(props) {
        return _super.call(this, props) || this;
    }
    PrivateRouteComponent.prototype.render = function () {
        var _a = this.props, authenticated = _a.authenticated, identity = _a.identity, permission = _a.permission, rest = __rest(_a, ["authenticated", "identity", "permission"]);
        if (!authenticated) {
            return (React.createElement(react_router_1.Redirect, { to: { pathname: '/login', state: { from: this.props.location } } }));
        }
        if (permission && !(0, index_1.userHasPermission)(identity, permission)) {
            return (React.createElement(react_router_1.Redirect, { to: { pathname: '/500', state: { from: this.props.location } } }));
        }
        return (React.createElement(react_router_1.Route, __assign({}, rest)));
    };
    return PrivateRouteComponent;
}(React.Component));
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return {
        authenticated: reducer.authentication.token !== null,
        identity: reducer.authentication.user,
    };
};
var mergeProps = function (stateProps, dispatchProps, ownProps) {
    return __assign(__assign(__assign({}, stateProps), dispatchProps), ownProps);
};
exports.PrivateRoute = (0, react_redux_1.connect)(mapStateToProps, null, mergeProps)(PrivateRouteComponent);
